import type { ResponseListOrganisationLoadBalancingGroups } from '../../app/ApiGen';
import { request } from '../../utils/request';

export type Response = ResponseListOrganisationLoadBalancingGroups;

export const getLoadBalancingGroups: (organisationId: string) => Promise<Response> = async (organisationId: string) =>
  request<Response>(`/organisations/${organisationId}/load-balancing-groups`, { method: 'GET' });
